import * as React from 'react';

import * as styles from './form_field.css';

interface IFormFieldProps {
  label: string;
  labelSup?: string;
  children: React.ReactNode;
}

const FormField = (props: IFormFieldProps) => {
  return (
    <div className={styles['field']}>
      <div className={styles['field-label']}>
        {props.label}
        {props.labelSup && <div className={styles['field-label--sup']}>{props.labelSup}</div>}
      </div>
      {props.children}
    </div>
  );
};

export { FormField };
